// Design System v2 — Reusable Style Primitives
// ============================================================
// TYPOGRAPHY SCALE
// ============================================================
export const type = {
    h1: { fontSize: 24, fontWeight: 700, letterSpacing: "-0.3px", lineHeight: 1.2 },
    h2: { fontSize: 20, fontWeight: 700, letterSpacing: "-0.2px", lineHeight: 1.25 },
    h3: { fontSize: 16, fontWeight: 600, letterSpacing: "-0.1px", lineHeight: 1.3 },
    body: { fontSize: 14, fontWeight: 400, lineHeight: 1.5 },
    sm: { fontSize: 13, fontWeight: 400, lineHeight: 1.4 },
    xs: { fontSize: 11, fontWeight: 500, lineHeight: 1.3 },
    cap: { fontSize: 11, fontWeight: 600, letterSpacing: "0.5px", textTransform: "uppercase", lineHeight: 1.3 },
};

// ============================================================
// SPACING SCALE (4px base)
// ============================================================
export const sp = { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, xxxl: 32 };

// ============================================================
// RADIUS SCALE
// ============================================================
export const rad = { sm: 8, md: 12, lg: 16, xl: 20, pill: 999 };

// ============================================================
// COMPONENT STYLES
// ============================================================

// Input field
export const inpS = (h) => ({
    width: "100%", padding: "12px 16px", borderRadius: rad.md, border: `1px solid ${h.bd}`,
    background: h.ib, color: h.tx, fontSize: 15, fontWeight: 400, outline: "none",
    boxSizing: "border-box", marginBottom: 12, transition: "border-color 0.2s, box-shadow 0.2s",
});

// Primary button — gradient accent
export const btnP = (h) => ({
    width: "100%", padding: "14px 20px", borderRadius: rad.md, border: "none",
    background: h.ac, color: "#fff", fontSize: 15, fontWeight: 600, cursor: "pointer",
    marginTop: 8, transition: "all 0.2s ease", letterSpacing: "0.1px",
    boxShadow: `0 2px 8px ${h.ac}30`,
});

// Secondary button
export const btnSec = (h) => ({
    width: "100%", padding: "14px 20px", borderRadius: rad.md,
    border: `1px solid ${h.bd}`, background: h.ib, color: h.ac,
    fontSize: 15, fontWeight: 500, cursor: "pointer", marginTop: 8,
    transition: "all 0.2s ease",
});

// Card
export const crd = (h) => ({
    background: h.cd, borderRadius: rad.lg, padding: sp.lg,
    marginBottom: sp.md, boxShadow: h.sh, border: `1px solid ${h.bd}`,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
});

// Elevated card (modals, dropdowns)
export const crdEl = (h) => ({
    background: h.el || h.cd, borderRadius: rad.lg, padding: sp.lg,
    boxShadow: h.s2 || h.sh, border: `1px solid ${h.b2 || h.bd}`,
});

// Badge / pill
export const bdg = (bg, c) => ({
    display: "inline-flex", alignItems: "center", background: bg, color: c,
    padding: "3px 10px", borderRadius: rad.pill, fontSize: 11, fontWeight: 600,
    letterSpacing: "0.1px", lineHeight: 1.4,
});

// Section header
export const secH = (h) => ({
    color: h.tx, fontSize: 15, fontWeight: 700, marginBottom: sp.md,
    letterSpacing: "-0.1px", display: "flex", alignItems: "center", gap: sp.sm,
});

// List item row
export const listRow = (h, last) => ({
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: `${sp.md}px ${sp.lg}px`, cursor: "pointer",
    borderBottom: last ? "none" : `1px solid ${h.bd}`,
    transition: "background 0.15s ease",
});

// Icon container (small square with tinted bg)
export const icBox = (color, size = 36) => ({
    width: size, height: size, borderRadius: rad.sm + 2,
    background: `${color}12`, display: "flex", alignItems: "center",
    justifyContent: "center", flexShrink: 0,
});
